// import React, { useEffect, useState, useContext } from "react";
// import MetisMenu from "metismenujs";
// import { Link, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import logodark from "../../assets/images/logo1.png";
// import logosmdark from "../../assets/images/logo-sm-dark.png";

// import { ColorModeContext } from "../../index";
// import medgeLight from "../../assets/images/medge_light.png";
// import medgeDark from "../../assets/images/medge_dark.png";

// const LIGHT_TOKENS = {
//   sidebarBg: "#e9e9e9",
//   textPrimary: "#333333",
//   textSecondary: "#6b7280",
//   activeColor: "#0b1d51",
//   activeBg: "rgba(13,71,161,0.06)",
//   mobilePanelBg: "#252b3b",
// };

// const DARK_TOKENS = {
//   sidebarBg: "#1d222e",
//   textPrimary: "#ffffff",
//   textSecondary: "#bbbbbb",
//   activeColor: "#4aa3ff",
//   activeBg: "rgba(74, 163, 255, 0.12)",
//   mobilePanelBg: "#252b3b",
// };

// const styles = {
//   logo: {
//     width: "100%",
//     maxWidth: "200px",
//     display: "block",
//     margin: "0 auto 15px",
//     marginTop: "10px",
//     transition: "filter 0.3s ease",
//   },
//   footer: {
//     textAlign: "center",
//     fontSize: "14px",
//     marginTop: "auto",
//     padding: "10px 0",
//   },
// };

// const SidebarContent = () => {
//   const organization = useSelector((state) => state.organization);
//   const location = useLocation();

//   const { mode } = useContext(ColorModeContext || { mode: "light" });
//   const T = mode === "dark" ? DARK_TOKENS : LIGHT_TOKENS;
// const isDark = mode === "dark";   // <-- add this

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768);
//   const [mobileChildren, setMobileChildren] = useState(null);

//   const mobilePanelStyle = {
//     position: "absolute",
//     left: "217px",
//     top: 0,
//     width: "200px",
//     backgroundColor: T.mobilePanelBg,
//     height: "100vh",
//     overflowY: "auto",
//     zIndex: 200,
//     padding: "10px",
//   };

//   const backButtonStyle = {
//     color: "#ffffff",
//     marginBottom: "10px",
//     cursor: "pointer",
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 768;
//       setIsMobile(mobile);
//       setIsCollapsed(mobile);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (isMobile) {
//       const sideMenu = document.getElementById("side-menu");
//       if (sideMenu) {
//         sideMenu.classList.remove("metismenu");
//         const cloned = sideMenu.cloneNode(true);
//         sideMenu.parentNode.replaceChild(cloned, sideMenu);
//       }
//     }
//   }, [isMobile]);

//   const user = localStorage.getItem("user")
//     ? JSON.parse(localStorage.getItem("user"))
//     : null;
//   const isSuperAdmin = user ? user.superadmin : false;
//   const permissions = user && user.permissions ? user.permissions : [];

//   useEffect(() => {
//     if (!isMobile) {
//       new MetisMenu("#side-menu");
//     }
//   }, [isMobile]);

//   const pathMatches = (to) => {
//     if (!to || typeof to !== "string") return false;
//     const norm = (str) => (str.endsWith("/") && str.length > 1 ? str.slice(0, -1) : str);
//     const cur = norm(location.pathname || "/");
//     const target = norm(to);
//     if (target === cur) return true;
//     try {
//       return cur.startsWith(target) && target !== "/";
//     } catch {
//       return false;
//     }
//   };

//   const isActiveItem = (item) => {
//     if (!item) return false;
//     if (item.to && pathMatches(item.to)) return true;
//     if (item.menu && Array.isArray(item.menu)) {
//       for (const child of item.menu) {
//         if (isActiveItem(child)) return true;
//       }
//     }
//     if (item.children && Array.isArray(item.children)) {
//       for (const child of item.children) {
//         if (isActiveItem(child)) return true;
//       }
//     }
//     return false;
//   };

//   const renderMenuItems = (menu, depth = 0) => {
//     return menu
//       .filter((item) =>
//         isSuperAdmin || permissions.some((perm) => perm.includes(item.id))
//       )
//       .map((item) => {
//         const showLabel = depth > 0 || !(isMobile && isCollapsed);
//         const linkClass =
//           depth === 0 && isMobile && isCollapsed
//             ? "waves-effect"
//             : "has-arrow waves-effect";

//         const active = isActiveItem(item);

//         const labelStyle = {
//           color: active ? T.activeColor : T.textSecondary,
//           fontWeight: active ? 700 : 500,
//           display: "inline-block",
//           verticalAlign: "middle",
//         };

//         const linkStyle = {
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           padding: depth === 0 ? "10px 12px" : "8px 24px",
//           background: active ? T.activeBg : "transparent",
//           borderLeft: active ? `3px solid ${T.activeColor}` : "3px solid transparent",
//           textDecoration: "none",
//         };

//         if (item.children && item.children.length > 0) {
//           return (
//             <li key={item.id}>
//               <Link
//                 to="#"
//                 className={linkClass}
//                 aria-expanded={active ? "true" : "false"}
//                 onClick={(e) => {
//                   if (isMobile && isCollapsed && depth === 0) {
//                     e.preventDefault();
//                     setMobileChildren(item.children);
//                   }
//                 }}
//                 style={linkStyle}
//                 aria-current={active ? "page" : undefined}
//               >
//                 <span style={{ display: "inline-flex", alignItems: "center", color: active ? T.activeColor : T.textSecondary }}>
//                   {item.icon && item.icon}
//                 </span>
//                 {showLabel && <span className="ms-1" style={labelStyle}>{item.Label}</span>}
//               </Link>
//               {(!isMobile || !isCollapsed || depth > 0) && (
//                 <ul className="sub-menu">
//                   {renderMenuItems(item.children, depth + 1)}
//                 </ul>
//               )}
//             </li>
//           );
//         } else {
//           return (
//             <li key={item.id}>
//               <Link to={item.to || "#"} className="waves-effect" style={linkStyle} aria-current={active ? "page" : undefined}>
//                 <span style={{ display: "inline-flex", alignItems: "center", color: active ? T.activeColor : T.textSecondary }}>
//                   {item.icon && item.icon}
//                 </span>
//                 {showLabel && <span className="ms-1" style={labelStyle}>{item.Label}</span>}
//               </Link>
//             </li>
//           );
//         }
//       });
//   };

//   return (
//     <div
//       id="sidebar-menu"
//       style={{
//         backgroundColor: T.sidebarBg,
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         position: "relative",
//         transition: "background-color 0.3s ease",
//       }}
//     >
//       <Link to="/home">
//         <img
//           src={isMobile ? logosmdark : logodark}
//           alt="Logo"
//           style={{
//             ...styles.logo,
//             filter: mode === "dark" ? "brightness(0) invert(1)" : "none",
//           }}
//         />
//       </Link>
//       <ul
//         id="side-menu"
//         className={
//           !isMobile || !isCollapsed
//             ? "metismenu list-unstyled"
//             : "list-unstyled"
//         }
//       >
//         {organization && organization.length > 0 ? (
//           organization.map((org) => {
//             if (org.id === "hospital") {
//               return org.options
//                 .filter((option) =>
//                   isSuperAdmin ||
//                   permissions.some((perm) => perm.includes(option.id))
//                 )
//                 .map((option) => {
//                   if (isMobile && isCollapsed) {
//                     return (
//                       <li key={option.id}>
//                         <Link
//                           to="#"
//                           className="waves-effect"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             setMobileChildren(option.menu);
//                           }}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             padding: "10px",
//                           }}
//                         >
//                           {option.icon && option.icon}
//                         </Link>
//                       </li>
//                     );
//                   } else {
//                     const optionActive = isActiveItem(option);
//                     const optionLabelStyle = {
//                       color: optionActive ? T.activeColor : T.textSecondary,
//                       fontWeight: optionActive ? 700 : 500,
//                     };
//                     return (
//                       <li key={option.id}>
//                         <Link
//                           to="#"
//                           className="has-arrow waves-effect"
//                           aria-expanded={optionActive ? "true" : "false"}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                             padding: "10px 12px",
//                             background: optionActive ? T.activeBg : "transparent",
//                             borderLeft: optionActive ? `3px solid ${T.activeColor}` : "3px solid transparent",
//                             textDecoration: "none",
//                           }}
//                         >
//                           {option.icon && <span style={{ color: optionActive ? T.activeColor : T.textSecondary }}>{option.icon}</span>}
//                           <span className="ms-1" style={optionLabelStyle}>
//                             {option.Label}
//                           </span>
//                         </Link>
//                         {option.menu && option.menu.length > 0 && (
//                           <ul className="sub-menu">
//                             {renderMenuItems(option.menu, 1)}
//                           </ul>
//                         )}
//                       </li>
//                     );
//                   }
//                 });
//             }
//             return null;
//           })
//         ) : (
//           <li style={{ color: T.textSecondary, padding: "10px" }}>No modules available</li>
//         )}
//       </ul>
//       {isMobile && mobileChildren && (
//         <div style={mobilePanelStyle}>
//           <div style={backButtonStyle} onClick={() => setMobileChildren(null)}>
//             &larr; Back
//           </div>
//           <ul className="list-unstyled">{renderMenuItems(mobileChildren, 1)}</ul>
//         </div>
//       )}

//   {/* Footer Branding */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: 8,
//           borderTop: "1px solid var(--hairline)",
//           backgroundColor: "var(--mist)",
//           textAlign: "center",
//           marginTop: "auto",
//           padding: "12px 0",
//         }}
//       >
//         <span style={{ fontSize: 13, color: "var(--slate)", whiteSpace: "nowrap", fontWeight: 500 }}>
//           Powered By
//         </span>
//         <img
//           src={isDark ? medgeDark : medgeLight}
//           alt="mEDGE Logo"
//           style={{
//             width: 65,
//             height: "auto",
//             display: "block",
//           }}
//         />
//       </div>
//     </div>
//   );
// };
// export default SidebarContent;

import React, { useEffect, useState, useContext } from "react";
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import logodark from "../../assets/images/mAuthenticate-logo.png";
import logosmdark from "../../assets/images/logo-sm-dark.png";
import medgeDarkBgSidebarF from "../../assets/images/medge_dark_bg-sidebarf.webp";
import { ColorModeContext } from "../../index";
import { IconButton } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { hasScimPermission, SCIM_PERMISSIONS } from "../../pages/ScimIntegrations/scimPermissions";
import { hasGatewayPermission, GATEWAY_PERMISSIONS } from "../../pages/GatewayMonitoring/gatewayPermissions";
import { hasFeatureAccess, isOrganizationOwner } from "../../utils/rbac";


/* =========================================================
   mEDGE design tokens (mirrors global.css :root values).
   Same variable names as global.css, remapped for dark mode.
   Applied via style={V} on the sidebar root — every inline
   style below reads var(--x) directly instead of a mode-
   branched hex object, so dark mode "just works" without a
   parallel token table.
   ========================================================= */

const LIGHT_VARS = {
  "--vault-navy": "#0B2545",
  "--edge-blue": "#1F6FEB",
  "--canvas": "#FFFFFF",
  "--mist": "#F7F9FC",
  "--hairline": "#E4E9F0",
  "--blue-tint": "#EAF2FE",
  "--slate": "#6B7A90",
  "--secure": "#00A88F",
  "--high": "#E2622B",
  "--elevated": "#F0A202",
  "--critical": "#D6323A",
  "--border-radius": "0px",
  "--sidebar-bg": "#0B2545",
  "--mobile-panel-bg": "#0B2545",
  "--sidebar-text": "#7A8A9E",
  "--sidebar-active-text": "#FFFFFF",
  "--sidebar-active-bg": "#1F6FEB", // Matches --edge-blue
};

const DARK_VARS = {
  "--vault-navy": "#F4F7FB",
  "--edge-blue": "#4C9AFF",
  "--canvas": "#0F1729",
  "--mist": "#252b3b",
  "--hairline": "rgba(255,255,255,0.14)",
  "--blue-tint": "rgba(76,154,255,0.16)",
  "--slate": "#93A4BD",
  "--secure": "#2FD3B8",
  "--high": "#F07C46",
  "--elevated": "#FFC24B",
  "--critical": "#FF6B72",
  "--border-radius": "4px",
  "--sidebar-bg": "#0B1527",
  "--mobile-panel-bg": "#0B1527",
  "--sidebar-text": "#7A8A9E",
  "--sidebar-active-text": "#FFFFFF",
  "--sidebar-active-bg": "#1F6FEB", // Matches active blue in picture
};

const styles = {
  logo: {
    width: "100%",
    maxWidth: "200px",
    display: "block",
    margin: "0 auto 15px",
    marginTop: "10px",
    transition: "filter 0.3s ease",
  },
  footer: {
    textAlign: "center",
    fontSize: "14px",
    marginTop: "auto",
    padding: "10px 0",
  },
};

const SidebarContent = ({ openSidebar, setOpenSidebar }) => {
  const organization = useSelector((state) => state.organization);
  const location = useLocation();

  const { mode } = useContext(ColorModeContext || { mode: "light" });
  const V = mode === "dark" ? DARK_VARS : LIGHT_VARS;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isCollapsed = !openSidebar; // Use openSidebar prop to determine collapse state
  const [mobileChildren, setMobileChildren] = useState(null);

  const mobilePanelStyle = {
    position: "absolute",
    left: "217px",
    top: 0,
    width: "200px",
    backgroundColor: "var(--mobile-panel-bg)",
    height: "100vh",
    overflowY: "auto",
    zIndex: 200,
    padding: "10px",
  };

  const backButtonStyle = {
    color: "#ffffff",
    marginBottom: "10px",
    cursor: "pointer",
    fontFamily: "Calibri, Arial, sans-serif",
    fontSize: "14px",
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const sideMenu = document.getElementById("side-menu");
      if (sideMenu) {
        sideMenu.classList.remove("metismenu");
        const cloned = sideMenu.cloneNode(true);
        sideMenu.parentNode.replaceChild(cloned, sideMenu);
      }
    }
  }, [isMobile]);

  const user = (typeof window !== "undefined" && (localStorage.getItem("user") || sessionStorage.getItem("user")))
    ? JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user"))
    : null;
  const isSuperAdmin = user ? isOrganizationOwner(user) : false;
  const permissions = user && user.permissions ? user.permissions : [];

  const isChildVisible = (child) => {
    if (!child) return false;
    if (isSuperAdmin) return true;
    if (child.id === 'Connections') {
      return hasScimPermission(user, SCIM_PERMISSIONS.READ);
    }
    if (child.id === 'Gateways') {
      return hasGatewayPermission(user, GATEWAY_PERMISSIONS.READ);
    }
    return hasFeatureAccess(user, child.id, 'read');
  };

  const isOptionVisible = (option) => {
    if (!option) return false;
    if (isSuperAdmin) return true;
    if (option.id === 'SCIM Integrations') {
      return hasScimPermission(user, SCIM_PERMISSIONS.READ);
    }
    if (option.id === 'Gateway Monitoring') {
      return hasGatewayPermission(user, GATEWAY_PERMISSIONS.READ);
    }
    if (option.menu && Array.isArray(option.menu) && option.menu.length > 0) {
      return option.menu.some(isChildVisible);
    }
    if (option.to) {
      return hasFeatureAccess(user, option.id, 'read');
    }
    return false;
  };

  const pathMatches = (to) => {
    if (!to || typeof to !== "string") return false;
    const norm = (str) => (str.endsWith("/") && str.length > 1 ? str.slice(0, -1) : str);
    const cur = norm(location.pathname || "/");
    const target = norm(to);
    if (target === cur) return true;
    try {
      return cur.startsWith(target) && target !== "/";
    } catch {
      return false;
    }
  };

  const isActiveItem = (item) => {
    if (!item) return false;
    if (item.to && pathMatches(item.to)) return true;
    if (item.menu && Array.isArray(item.menu)) {
      for (const child of item.menu) {
        if (isActiveItem(child)) return true;
      }
    }
    if (item.children && Array.isArray(item.children)) {
      for (const child of item.children) {
        if (isActiveItem(child)) return true;
      }
    }
    return false;
  };

  const renderMenuItems = (menu, depth = 0) => {
    return menu
      .filter(isChildVisible)
      .map((item) => {
        const showLabel = depth > 0 || !(isMobile && isCollapsed);
        const linkClass =
          depth === 0 && isMobile && isCollapsed
            ? "waves-effect"
            : "has-arrow waves-effect";

        const active = isActiveItem(item);

        const labelStyle = {
          color: active ? "var(--sidebar-active-text)" : "var(--sidebar-text)",
          fontFamily: "Calibri, Arial, sans-serif",
          fontWeight: active ? 700 : 400,
          fontSize: "17px",
          display: "inline-block",
          verticalAlign: "middle",
        };

        const linkStyle = {
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: depth === 0 ? "10px 12px" : "8px 24px",
          background: active ? "var(--sidebar-active-bg)" : "transparent",
          borderLeft: active ? "3px solid var(--edge-blue)" : "3px solid transparent",
          borderRadius: "var(--border-radius)",
          textDecoration: "none",
        };

        if (item.children && item.children.length > 0) {
          return (
            <li key={item.id}>
              <Link
                to="#"
                className={linkClass}
                aria-expanded={active ? "true" : "false"}
                onClick={(e) => {
                  if (isMobile && isCollapsed && depth === 0) {
                    e.preventDefault();
                    setMobileChildren(item.children);
                  }
                }}
                style={linkStyle}
                aria-current={active ? "page" : undefined}
              >
                <span style={{ display: "inline-flex", alignItems: "center", color: active ? "var(--sidebar-active-text)" : "var(--sidebar-text)" }}>
                  {item.icon && item.icon}
                </span>
                {showLabel && <span className="ms-1" style={labelStyle}>{item.Label}</span>}
              </Link>
              {(!isMobile || !isCollapsed || depth > 0) && (
                <ul className="sub-menu">
                  {renderMenuItems(item.children, depth + 1)}
                </ul>
              )}
            </li>
          );
        } else {
          return (
            <li key={item.id}>
              <Link to={item.to || "#"} className="waves-effect" style={linkStyle} aria-current={active ? "page" : undefined}>
                <span style={{ display: "inline-flex", alignItems: "center", color: active ? "var(--sidebar-active-text)" : "var(--sidebar-text)" }}>
                  {item.icon && item.icon}
                </span>
                {showLabel && <span className="ms-1" style={labelStyle}>{item.Label}</span>}
              </Link>
            </li>
          );
        }
      });
  };

  return (
    <div
      id="sidebar-menu"
      style={{
        ...V,
        backgroundColor: "var(--sidebar-bg)",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        position: "relative",
        transition: "background-color 0.3s ease",
        borderRight: "1px solid var(--hairline)",
        borderColor: "rgba(255,255,255,0.1)", // Darker border on dark background
        borderLeft: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: isCollapsed ? "center" : "space-between",
          height: "96px",
          minHeight: "96px",
          padding: isCollapsed ? "0" : "0 16px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          transition: "all 0.3s ease",
          boxSizing: "border-box",
        }}
      >
        {!isCollapsed && (
          <Link to="/home" style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logodark}
              alt="Logo Full"
              style={{
                height: "44px",
                maxHeight: "48px",
                width: "auto",
                maxWidth: "160px",
                transition: "opacity 0.3s ease",
                objectFit: "contain",
              }}
            />
          </Link>
        )}
        <IconButton
          onClick={() => setOpenSidebar(!openSidebar)}
          sx={{ color: 'white' }}
        >
          <MenuIcon fontSize="large" />
        </IconButton>
      </div>
      <ul
        id="side-menu"
        className={
          !isMobile || !isCollapsed
            ? "metismenu list-unstyled"
            : "list-unstyled"
        }
      >
        {organization && organization.length > 0 ? (
          organization.map((org) => {
            if (org.id === "hospital") {
              return org.options
                .filter(isOptionVisible)
                .map((option) => {
                  return (
                    <React.Fragment key={option.id}>
                      <li className="menu-title" style={{
                        display: isCollapsed ? "none" : "block",
                        padding: isCollapsed ? "0px 20px" : "12px 20px",
                        color: "#6b7a90",
                        fontSize: "11px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        marginTop: isCollapsed ? "0px" : "0px",
                        opacity: isCollapsed ? 0 : 1,
                        maxHeight: isCollapsed ? "0px" : "40px",
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                        whiteSpace: "nowrap"
                      }}>
                        {option.Label}
                      </li>
                      {option.menu && option.menu.length > 0 && (
                        option.menu
                          .filter(isChildVisible)
                          .map(child => {
                          const childActive = isActiveItem(child);
                          const childLabelStyle = {
                            color: childActive ? "var(--sidebar-active-text)" : "var(--sidebar-text)",
                            fontFamily: "Calibri, Arial, sans-serif",
                            fontWeight: childActive ? 700 : 400,
                            fontSize: "15px",
                          };
                          const linkStyle = {
                            display: "flex",
                            alignItems: "center",
                            padding: "10px 14px",
                            justifyContent: "flex-start",
                            background: childActive ? "var(--sidebar-active-bg)" : "transparent",
                            borderRadius: "8px",
                            textDecoration: "none",
                            margin: "4px 12px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            transition: "background 0.2s ease, margin 0.3s ease",
                          };
                          return (
                            <li key={child.id}>
                              <Link to={child.to || "#"} className="waves-effect" style={linkStyle}>
                                {child.icon && (
                                  <span style={{
                                    color: childActive ? "var(--sidebar-active-text)" : "var(--sidebar-text)",
                                    display: "flex",
                                    alignItems: "center",
                                    minWidth: "22px",
                                    justifyContent: "center",
                                  }}>
                                    {child.icon}
                                  </span>
                                )}
                                <span className="ms-1" style={{
                                  ...childLabelStyle,
                                  marginLeft: "12px",
                                  opacity: isCollapsed ? 0 : 1,
                                  transition: "opacity 0.3s ease",
                                  display: "inline-block",
                                }}>
                                  {child.Label}
                                </span>
                              </Link>
                            </li>
                          );
                        })
                      )}
                    </React.Fragment>
                  );
                });
            }
            return null;
          })
        ) : (
          <li style={{ color: "var(--slate)", fontFamily: "Calibri, Arial, sans-serif", padding: "10px" }}>
            No modules available
          </li>
        )}
      </ul>
      {isMobile && mobileChildren && (
        <div style={mobilePanelStyle}>
          <div style={backButtonStyle} onClick={() => setMobileChildren(null)}>
            &larr; Back
          </div>
          <ul className="list-unstyled">{renderMenuItems(mobileChildren, 1)}</ul>
        </div>
      )}
      <div
        style={{
          display: isCollapsed ? "none" : "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px 0",
          marginTop: "auto",
          width: "100%",
          boxSizing: "border-box",
          transition: "all 0.3s ease",
          whiteSpace: "nowrap",
          overflow: "hidden",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        {!isCollapsed && (
          <>
            <span
              style={{
                fontSize: 13,
                color: "var(--slate)",
                fontWeight: 500,
                marginRight: "8px",
              }}
            >
              Powered By
            </span>
            <img
              src={medgeDarkBgSidebarF}
              alt="Medge.io"
              style={{
                width: 70,
                height: "auto",
                display: "block",
                transition: "filter 0.3s ease",
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SidebarContent;